import { Component, OnInit, Injectable, ViewChild, AfterViewChecked, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import * as $ from 'jquery';
import 'jquery.nicescroll';
import 'layui-layer';
import { List } from "linqts";
import { GroupByPipe } from 'ng-pipes';
import { UgService } from './../../services/ug.service';
import { AppConfig } from './../app.config';
import { StorageService } from './../../providers/storage.service';
import { Router } from '@angular/router';
import { AlertService } from './../../providers/alert.service';
import { AuthService } from '../../providers/auth.service';
import { UserVarifyService } from './../../services/userVarify.service';
import { UserModel } from './../../models/user.model';
import { IndexService } from './../../services/index.service';
import { SignalrService } from "../../providers/signalr.service";
import { setTimeout, clearTimeout } from 'timers';
import { SysconfigService } from '../../services/sysconfig.service';
import { KaiYuanService } from './../../services/kaiyuan.service';
import { Observable } from "rxjs/Rx";
import Moment from 'moment';
import 'jquery.qrcode';

import { BettingOrderHelper } from "./../../services/bettingorder.helper";
import { RebateService } from '../../services/rebate.service';
import { EbetService } from './../../services/ebet.service';
import { ChatService } from '../../services/chat.service';
import { FormBuilder, FormControl } from '@angular/forms';
const config = require("./../../assets/config/config.json");
import { DomSanitizer } from '@angular/platform-browser';
import { SigninService } from '../../services/signin.service';
@Component({
    selector: 'app-pages',
    template: require('./pages.component.html'),
    styles: [require('./pages.component.scss')],
    providers: [
        UserVarifyService,
        IndexService,
        GroupByPipe,
        UgService,
        SysconfigService,
        KaiYuanService,
        BettingOrderHelper,
        EbetService,
        ChatService,
        RebateService,
        SigninService
    ]
})
@Injectable()
export class PagesComponent implements OnInit, OnDestroy {


    switchValue = false;
    isNotice = true;
    vrStatus: boolean = false;
    messageForm: any;
    isMessage: boolean = false;  //是否显示右边的聊天窗口
    showChatModal: boolean = false; //是否显示聊天模态窗
    disableScrollDown = false
    isBanned: boolean = false;   //是否禁言
    isBlacklist: boolean = false; //是否是黑名单
    messageInfo;
    currentChatUser;
    badgenNum: number = 0;  //未读消息总数
    poll;  //定时轮询
    pollMessageNum
    isHide: boolean = false;
    isLoadMore: boolean = false;
    isCkSimplePwd: boolean = false;//接受密码是否合格
    StorageUser;//拿取缓存的User
    history;  //历史消息
    subscribeScoll: any;
    imShow = true;
    isOpenChat = true;//是否开启上下级聊天
    /**
     * 当前联系人
     */
    currentChat;
    /**
 * 下级用户
 */
    subordinates;
    guajiTimer
    constructor(
        private router: Router,
        private appconfig: AppConfig,
        private storage: StorageService,
        private alert: AlertService,
        private auth: AuthService,
        private userservice: UserVarifyService,
        private cookie: CookieService,
        private groupBy: GroupByPipe,
        private indexService: IndexService,
        private signalr: SignalrService,
        private ugService: UgService,
        private sysconfig: SysconfigService,
        private kaiyuanService: KaiYuanService,
        private bettinghelper: BettingOrderHelper,
        private eService: EbetService,
        private chatService: ChatService,
        public formBuilder: FormBuilder,
        private sanitizer: DomSanitizer,
        private rebateService: RebateService,
        private signinService: SigninService,


    ) {
        this.messageForm = formBuilder.group({
            message: new FormControl('')
        });
        AppConfig.connetionFlag = true;
        this.guajiTimer = setInterval(() => {
            this.GetHangonToolSettings();
        }, 5000);
    }
    isShow = true;
    AppConfig = AppConfig;
    //侧拉栏开关
    navShow: boolean = true;
    maxID;
    minID;
    isAlertChangePassword: boolean = false; // 是否弹出密码框
    //当前登录用户
    currUser;
    ttLottery = []; //时时彩数据
    //所有彩种
    lotterys = [];
    //一个彩种的彩票
    lotteryPlays;
    //当前彩票的code
    currlotteryCode = '10001';
    //声音开关状态
    soundState: boolean = false;
    isRefresh: boolean = false;//刷新金额状态
    isCollapsed = false;
    isShowChat = false;
    //vr
    isWechat = false;
    imurl; //聊天链接
    isSam: boolean;


    oneOpen;
    twoOpen;
    threeOpen;
    fourOpen;
    fiveOpen;
    sixOpen;

    vrModel: any;
    /**
        * 侧拉栏打开关闭判定
        *  openArr[0]如何进行微信推广
        *  openArr[1]如何申请谷歌密码
        *  openArr[2]游戏官方网站地址
        *  openArr[3]自动投注/挂机地址
        *  openArr[4]计划软件网页版
        *  openArr[5]**品牌
        *  openArr[6]KY
        *  openArr[7]AG
        *  openArr[8]EBET
        *  openArr[9]UG
        *  openArr[10]GamMa
        *  * openArr[11]ImDJ
        * @memberof PagesComponent
        */
    openNavArr = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]
    interval = null;
    isDownload = false;


    isBalance: boolean = true;
    isUserNav: boolean = true;
    isNavMenu: boolean = true;
    deg = 0;
    appInfo = {
        AndroidContent: "",
        AndroidDate: "",
        AndroidUrl: "",
        AndroidVersion: "",
        IosContent: "",
        IosDate: "",
        IosUrl: "",
        IosVersion: "",
        IsOpen: true
    }
    activeLottery: number;
    //客服二维码图片
    qrcode1;
    qrcode2;

    // thirdGameList = [
    //     {
    //         code: "pmreal",
    //         router: "/app/pm",
    //         name: "DB真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/third-img/icon-pm.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "ag",
    //         router: "/app/ag",
    //         name: "AG真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-zhenren.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "bg",
    //         router: "/app/bg",
    //         name: "BG真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/third-img/icon-bg.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "ebet",
    //         router: "/app/ebet",
    //         name: "WE真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-ebet.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "oubo",
    //         router: "/app/oubo",
    //         name: "欧博真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/pages/oubo_hover.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "yblive",
    //         router: "/app/yabo-live",
    //         name: "OB真人",
    //         status: false,
    //         img: "../../assets/imgs/pages/yblive.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "yx",
    //         router: "/app/yaxing",
    //         name: "YX真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-yx.png",
    //         isOpen: false,
    //     },


    //     {
    //         code: "bs",
    //         router: "/app/bs",
    //         name: "BS百胜棋牌",
    //         status: false,
    //         img: "../../assets/imgs/pages/bs.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "ky",
    //         router: "/app/kaiyuan",
    //         name: "KY开元棋牌",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-kaiyuan.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "yb",
    //         router: "/app/yabo",
    //         name: "OB棋牌",
    //         status: false,
    //         img: "../../assets/imgs/pages/yb.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "jm",
    //         router: "/app/gamma",
    //         name: "GM加玛棋牌",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-gamma.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "kx",
    //         router: "/app/kaixuan",
    //         name: "KX凯旋棋牌",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-kaixuan.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "cr",
    //         router: "/app/cr",
    //         name: "CR皇冠体育",
    //         status: false,
    //         img: "../../assets/imgs/pages/cr_hover.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "pg",
    //         router: "/app/pg",
    //         name: "PG电子",
    //         status: false,
    //         img: "../../assets/imgs/pages/pg_hover.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "sb",
    //         router: "/app/shaba",
    //         name: "AIO沙巴体育",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-ug.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "im2",
    //         router: "/app/im",
    //         name: "IM体育",
    //         status: false,
    //         img: "../../assets/imgs/pages/im.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "ob",
    //         router: "/app/ob",
    //         name: "DB体育",
    //         status: false,
    //         img: "../../assets/imgs/pages/ob.png",
    //         isOpen: false,
    //     },
    // ];

    // thirdGameList = [
    //     {
    //         code: "ag",
    //         router: "/app/ag",
    //         name: "AG真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-zhenren.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "pmreal",
    //         router: "/app/pm",
    //         name: "DB真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/third-img/icon-pm.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "bg",
    //         router: "/app/bg",
    //         name: "BG真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/third-img/icon-bg.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "ebet",
    //         router: "/app/ebet",
    //         name: "WE真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-ebet.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "oubo",
    //         router: "/app/oubo",
    //         name: "欧博真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/pages/oubo_hover.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "bs",
    //         router: "/app/bs",
    //         name: "BS百胜棋牌",
    //         status: false,
    //         img: "../../assets/imgs/pages/bs.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "ky",
    //         router: "/app/kaiyuan",
    //         name: "KY开元棋牌",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-kaiyuan.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "cr",
    //         router: "/app/cr",
    //         name: "CR皇冠体育",
    //         status: false,
    //         img: "../../assets/imgs/pages/cr_hover.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "im2",
    //         router: "/app/im",
    //         name: "IM体育",
    //         status: false,
    //         img: "../../assets/imgs/pages/im.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "ob",
    //         router: "/app/ob",
    //         name: "DB体育",
    //         status: false,
    //         img: "../../assets/imgs/pages/ob.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "pg",
    //         router: "/app/pg",
    //         name: "PG电子",
    //         status: false,
    //         img: "../../assets/imgs/pages/pg_hover.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "yblive",
    //         router: "/app/yabo-live",
    //         name: "OB真人",
    //         status: false,
    //         img: "../../assets/imgs/pages/yblive.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "yx",
    //         router: "/app/yaxing",
    //         name: "YX真人视讯",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-yx.png",
    //         isOpen: false,
    //     },
    
    
    //     {
    //         code: "yb",
    //         router: "/app/yabo",
    //         name: "OB棋牌",
    //         status: false,
    //         img: "../../assets/imgs/pages/yb.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "jm",
    //         router: "/app/gamma",
    //         name: "GM加玛棋牌",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-gamma.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "kx",
    //         router: "/app/kaixuan",
    //         name: "KX凯旋棋牌",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-kaixuan.png",
    //         isOpen: false,
    //     },
    //     {
    //         code: "sb",
    //         router: "/app/shaba",
    //         name: "AIO沙巴体育",
    //         status: false,
    //         img: "../../assets/imgs/pages/icon-ug.png",
    //         isOpen: false,
    //     },
    // ];

    thirdGameList = []

    /**
     * 上级用户
     */
    superior;
    chatBox: any;
    user = this.appconfig.getCurrentUser();
    userName = this.user.UserName;
    pwdParams = { isPwd: false, oldpwd: '', newpwd: '', commpwd: '', username: this.userName };
    // 侧拉栏彩种图片
    withVrnavImg = {
        "01": '../../assets/imgs/pages/icon-shishicai.png',
        "10": '../../assets/imgs/pages/icon-kuaile8.png',
        "02": '../../assets/imgs/pages/icon-11xuan5.png',
        "08": '../../assets/imgs/pages/icon-pk.png',
        "07": '../../assets/imgs/pages/icon-kuai3.png',
        "03": '../../assets/imgs/pages/icon-others.png',
        "11": '../../assets/imgs/pages/icon-liuhecai.png',
        'vr': "../../assets/imgs/pages/icon-VR.png"
    };

    withVrFlagArr = ["ugOpen", "vrOpen", "oneOpen", "twoOpen", "threeOpen", "fourOpen", "fiveOpen", "sixOpen"];
    withinVrFlagArr = ["ugOpen", "oneOpen", "twoOpen", "threeOpen", "fourOpen", "fiveOpen", "sixOpen"];
    smallOpenFlag = 100;
    submenus;
    signalrUrl;//signalr地址
    logoSrc: string = '';//品牌logo
    year: number;
    kaiyuanStatus: boolean = false; //开元棋牌开启状态
    baishengStatus: boolean = false;
    zodiacArr = ["鼠", "牛", "虎", "兔", "龙", "蛇", "马", "羊", "猴", "鸡", "狗", "猪"];
    selectedOption
    searchOptions = [
        { value: 'jack', label: 'Jack' },
        { value: 'lucy', label: 'Lucy' },
        { value: 'tom', label: 'Tom' }
    ];
    /**
     *计算获取不同生肖年份次数
     * @type {number}
     * @memberof PagesComponent
     */
    countZodiac: number = 0;

    /**
     *
     *插入本年或上一年生肖对象标识
     * @memberof PagesComponent
     */
    flagZodiac = false;

    /**
     *时间戳赋值暂存
     * @type {number}
     * @memberof PagesComponent
     */
    timeTemp: number;

    /**
     *获取时间戳计数器阈值
     * @type {number}
     * @memberof PagesComponent
     */
    timeCount: number = 1;

    guaji;

    public ngOnInit() {
        this.imurl = 'http://gmysql.dlhzw.com?apiUrl=' + 'http://' + document.location.host + '&token=' + localStorage.getItem('token');
        this.imurl = this.sanitizer.bypassSecurityTrustResourceUrl(this.imurl);
        //     ["确认", "取消"], (yes) => {
        //         this.submitBettingLott(isonebet, isChase);
        //     }, cancel => {
        //     });
        // } else {
        //     this.submitBettingLott(isonebet, isChase);
        // }
        // this.alert.WarnInfor("tishi", "与Message类似，如果要修改message的默认配置，你可以设置提供商NZ_NOTIFICATION_CONFIG的值来修改。与Message类似，如果要修改message的默认配置，你可以设置提供商NZ_NOTIFICATION_CONFIG的值来修改。");
        // this.getSuperior();
        this.StorageUser = this.storage.read('User');
        if (!this.StorageUser['GASecret']) {
            const encodePassord = this.storage.readString('encodepwd');
            let decodePwd = "";
            if (encodePassord) {
                decodePwd = new Buffer(encodePassord, 'base64').toString();
            }
            this.signinService.IsCkSimplePwd({ userpwd: decodePwd }).then(s => {
                if (s.Result) {
                    this.alert.confirmAlert('您的登陆密码过于简单，建议您修改登录密码，并绑定谷歌登陆验证器，提高账户安全性。（纯数字；单个字母加连贯数字；与账户相同的密码都为简单密码）。', '温馨提示', ['确认修改'], yes => {
                        this.isAlertChangePassword = true;
                    }, (end) => {
                        this.isAlertChangePassword = true;
                    })
                } else {
                }
            });
        }
        this.getChatSetting();
        Observable.fromEvent(window, 'resize').debounceTime(100).subscribe((event: any) => {
            if (event.target.innerWidth < 1560) {
                this.isUserNav = true;
                this.isNavMenu = false;
            } else {
                this.isNavMenu = true;
                this.isUserNav = true;
            }
        })
        let time = 1000 * 25;
        this.getCacheClean();
        this.getThirdIsOpen();
        this.getOpenGames();
        AppConfig.getCacheTimer = setInterval(() => {
            this.getCacheClean();
        }, time);
        this.year = new Date().getFullYear();
        this.getAllLottery();
        this.currUser = this.appconfig.getCurrentUser();

        let tempLetterys = [];
        let tempLetteryCodes = ["SSC", 'GFC', "PK10", "L11X5", "KUAI3"];
        tempLetteryCodes.forEach(code => {
            let lottery = this.appconfig.getIndexLotterys().find(s => {
                return code == s.type;
            });
            if (lottery)
                tempLetterys.push(lottery);
        })
        this.lotterys = tempLetterys;
        this.submenus = [
            {
                id: 0, title: "代理中心", link: '/app/manager/agent-center', vrStatu: true, child: [
                    { id: 0, title: "团队总览", link: '/app/manager/agent-center/teamOverview', isSafe: false, vrStatu: true, isVip: this.currUser.UserType },
                    { id: 1, title: "开户中心", link: '/app/manager/agent-center/acount-center', isSafe: false, vrStatu: true, isVip: this.currUser.UserType },
                    { id: 2, title: "团队管理", link: '/app/manager/agent-center/agent-management', isSafe: false, vrStatu: true, isVip: this.currUser.UserType },
                    { id: 3, title: "在线会员", link: '/app/manager/agent-center/onlinemember', isSafe: false, vrStatu: true, isVip: this.currUser.UserType },
                    { id: 5, title: "团队报表", link: '/app/manager/agent-center/teamReport', isSafe: false, vrStatu: true, isVip: this.currUser.UserType },
                    { id: 6, title: "游戏记录", link: '/app/manager/agent-center/gameRecord', isSafe: false, vrStatu: true, isVip: this.currUser.UserType },
                    { id: 7, title: "追号记录", link: '/app/manager/agent-center/appendRecord', isSafe: false, vrStatu: true, isVip: this.currUser.UserType },
                    { id: 8, title: "帐变记录", link: '/app/manager/agent-center/billRecord', isSafe: false, vrStatu: true, isVip: this.currUser.UserType },
                    // { id: 4, title: "日工资设置", link: '/app/manager/agent-center/dailywages', isSafe: false, vrStatu: true },
                    // {id:6,title:"分红",link:'/app/manager/agent-center/dividends'}
                ]
            },
            {
                id: 1, title: "报表中心", link: '/app/manager/report-record', vrStatu: true, child: [
                    { id: 0, title: "主账户报表", link: '/app/manager/report-record/acountReport', isSafe: false, vrStatu: true, isVip: 1 },
                    { id: 1, title: "游戏记录", link: '/app/manager/report-record/gameRecord', isSafe: false, vrStatu: true, isVip: 1 },
                    { id: 2, title: "追号记录", link: '/app/manager/report-record/appendRecord', isSafe: false, vrStatu: true, isVip: 1 },
                    { id: 3, title: "帐变记录", link: '/app/manager/report-record/billRecord', isSafe: false, vrStatu: true, isVip: 1 }
                ]
            },
            {
                id: 2, title: "VR报表中心", link: '/app/manager/vrreport-record', vrStatu: this.vrStatus, child: [
                    { id: 0, title: "VR游戏记录", link: '/app/manager/vrreport-record/vrgame-record', isSafe: false, vrStatu: this.vrStatus, isVip: 1 },
                    { id: 1, title: "VR追号记录", link: '/app/manager/vrreport-record/vrappend-record', isSafe: false, vrStatu: this.vrStatus, isVip: 1 },
                    { id: 2, title: "VR盈亏统计", link: '/app/manager/vrreport-record/vrprofit', isSafe: false, vrStatu: this.vrStatus, isVip: 1 },
                    { id: 3, title: "VR帐变记录", link: '/app/manager/vrreport-record/vrbill-record', isSafe: false, vrStatu: this.vrStatus, isVip: 1 },
                    { id: 4, title: "VR电子游戏记录", link: '/app/manager/vrreport-record/video-game-record', isSafe: false, vrStatu: this.vrStatus, isVip: 1 }
                ]
            },

            {
                id: 5, title: '财务中心', link: '/app/manager/financial-center', vrStatu: true, child: [
                    { id: 0, title: "充值", link: '/app/manager/financial-center/recharge', isSafe: false, vrStatu: true, isVip: 1 },
                    { id: 1, title: "提现", link: '/app/manager/financial-center/withdraw', isSafe: false, vrStatu: true, isVip: 1 },
                    { id: 2, title: "充值记录", link: '/app/manager/financial-center/recharge-record', isSafe: false, vrStatu: true, isVip: 1 },
                    { id: 3, title: "提现记录", link: '/app/manager/financial-center/withdraw-record', isSafe: false, vrStatu: true, isVip: 1 }
                    // {id:4,title:"账变记录",link:'/app/manager/financial-center/bill-record'}
                ]
            },
            {
                id: 6, title: "安全中心", link: '/app/manager/message-center', vrStatu: true, child: [
                    { id: 0, title: "个人中心", link: '/app/manager/user-center', isSafe: true, vrStatu: true, isVip: 1, type: 1 },
                    // { id: 0, title: "安全中心", link: '/app/manager/user-center', isSafe: true, vrStatu: true, isVip: 1, type: 2 }
                ]
            },

            {
                id: 7, title: "服务中心", vrStatu: true, img: 'anticon anticon-heart', child: [
                    // { id: 0, title: "收件箱", link: '/app/manager/message-center/inbox' },
                    // { id: 1, title: "发件箱", link: '/app/manager/message-center/outbox' },
                    // { id: 2, title: "写消息", link: '/app/manager/message-center/sendmessage' }
                    { id: 0, title: "帮助中心", link: '/app/xbbrand/about-us', isSafe: false, vrStatu: true, isVip: 1 }
                ]
            }
        ]
        //分出 急速彩
        // let tmp = (new List(this.lotterys[0]['plays']).Where(s => {
        //     return s['LotteryName'].indexOf('时时彩') > -1 || s['LotteryName'] == '台湾5分彩'
        // })).ToArray();

        //急速彩
        // let plays = (new List(this.lotterys[0]['plays']).Where(s => {
        //     return s['LotteryName'].indexOf('分') > -1 && s['LotteryName'] != '台湾5分彩'
        // })).ToArray();
        // 时时彩去掉急速彩
        // this.lotterys.forEach(s => {
        //     if (s['name'] == '时时彩') {
        //         s['plays'] = tmp;
        //     }
        // });

        // let tmplottery = { 'code': '10', 'name': '急速彩', 'plays': plays };
        // this.lotterys.unshift(tmplottery);

        /*
        if (this.currUser.UserType == '3') {
           this.submenus[0].child.push({ id: 6, title: "分红", link: '/app/manager/agent-center/dividends' });
       } */

        if (this.currUser.HasDailyWages && this.currUser.UserType == '1') {
            let submenu1: any[] = this.submenus[0].child;
            let submenu2: any[] = this.submenus[1].child;
            submenu1.push({ id: 4, title: "日工资设置", link: '/app/manager/agent-center/dailywages', isSafe: false, vrStatu: true, isVip: this.currUser.UserType });
            submenu2.push({ id: 4, title: "日工资报表", link: '/app/manager/report-record/dailywagesreport', isSafe: false, vrStatu: true, isVip: 1 });
            this.submenus[0].child = submenu1;
            this.submenus[1].child = submenu2;
        }
        // this.addHotIcon();
        if (this.currUser == null || this.lotterys == null) {
            this.alert.errorAlert('请先登录');
            this.router.navigateByUrl('login');
            return;
        }

        if (this.auth.loggedIn()) {
            this.sysconfig.getSignalr().then(s => {
                this.signalrUrl = s;
                this.signalr.init(this.signalrUrl);
            }).catch(err => {
                this.signalr.init(this.signalrUrl);
            })
        } else {
            this.router.navigateByUrl('login');
            return;
        }

        this.LotteryTypeClick(this.lotterys[0].plays);
        this.soundState = this.cookie.get('openSound') == 'on' ? true : false;
        this.userservice.getCurrUserUnReadCount().then(s => {
            AppConfig.unreadCount = s;
            if (AppConfig.unreadCount >= 99) {
                AppConfig.unreadCount = 99;
            }
        });
        this.voiceSwitchInit();
        this.getAnnouncements();
        this.taggles();

        //判断VR是否开启
        this.indexService.getAgStatus().then(s => {
            this.vrStatus = s.Result;

            this.submenus.forEach((v, i) => {
                if (v.title == "VR报表中心") {
                    v.vrStatu = this.vrStatus;
                    let vrSubmenu: any[] = v.child;
                    vrSubmenu.forEach((k) => {
                        k.vrStatu = this.vrStatus;
                    });
                    v.child = vrSubmenu;
                }
            });
            if (this.vrStatus) {
                this.vrIsOpen();
                for (let i = 0; i < this.lotterys.length; i++) {
                    this.lotterys[i].openFlag = this.withVrFlagArr[i];
                    this.lotterys[i].img = this.withVrnavImg[this.lotterys[i].code];
                }
                this.lotteryInit();
            } else {
                for (let i = 0; i < this.lotterys.length; i++) {
                    this.lotterys[i].openFlag = this.withinVrFlagArr[i];
                    this.lotterys[i].img = this.withVrnavImg[this.lotterys[i].code];
                }
                this.lotteryInit();
            }
        });

        //ebet是否开启
        // this.eService.ebetStatus().then(s => {
        //     if (s && s.Result) {
        //         this.ebetFlag = s.Result;
        //     }
        // }).catch(e => {
        //     console.log(e);
        //     this.ebetFlag = false;
        // })


        // this.getkefuqecode();
        // this.getLogoPic();
        // this.getKaiYuanOpenStatus();
        this.MarksixSettings();
        this.getUserIsPrivateReturn();
    }
    getUserIsPrivateReturn() {
        this.rebateService.getUserIsPrivateReturn().then(res => {
            if (res.Parameter == '1') {
                let submenu1: any[] = this.submenus[0].child;
                submenu1.push(
                    { id: 20, title: "私返设置", link: '/app/manager/agent-center/rebate-set', isSafe: false, vrStatu: true, isVip: this.currUser.UserType }

                );
                this.submenus[0].child = submenu1;
            }
        })
    }
    /**
     * 获取六合彩年份
     * sing 2018-12-24
     * @memberof PagesComponent
     */
    MarksixSettings() {
        this.sysconfig.MarksixSettings().then(res => {
            if (res && Number(res.LiuhecaiHXDate) > 1) {
                AppConfig.lhcYear = Number(res.LiuhecaiHXDate);
                if (res.LotteryIssues.length) {
                    res.LotteryIssues.forEach(element => {
                        if (element.LotteryCode == '95000') {
                            AppConfig.beginIssue = Number(element.StartIssue);
                        }
                    });
                }
            } else {
                AppConfig.lhcYear = config.year;
            }
            // console.log(AppConfig.lhcYear,AppConfig.beginIssue);
            this.getZodiacArr();
        }).catch(err => {
            AppConfig.lhcYear = config.year;
            this.getZodiacArr();
        })
    }

    /**
     * 获取当前年份生肖数组，下标对应生肖
     * sing 2019-01-15
     * @memberof PagesComponent
     */
    getZodiacArr() {
        this.zodiacArr.forEach((element, k) => {
            this.bettinghelper.getNumberByZodiacOrLastWord(element).forEach((e, i) => {
                if (e.toString().length == 1) {
                    e = '0' + e.toString();
                };
                if (!this.flagZodiac) {
                    AppConfig.numZodiacArr[e] = element;
                } else {
                    AppConfig.numZodiacLastArr[e] = element;
                };
                if (k == this.zodiacArr.length - 1 && i == this.bettinghelper.getNumberByZodiacOrLastWord(element).length - 1 && this.countZodiac == 0) {
                    this.countZodiac++;
                    AppConfig.lhcYear--;
                    this.flagZodiac = true;
                    this.getZodiacArr();
                } else if (k == this.zodiacArr.length - 1 && i == this.bettinghelper.getNumberByZodiacOrLastWord(element).length - 1 && this.flagZodiac) {
                    AppConfig.lhcYear++;
                }
            })
        });

    }

    /**
     *查询游戏玩法明细时间戳
     *
     * @memberof PagesComponent
     */
    getCacheClean() {
        this.sysconfig.getCacheClean().then((res: CacheModel) => {
            if (res.InnerMessage.indexOf('成功') >= 0 && res.Value.Timestamp) {
                AppConfig.timing = res.Value.Timestamp;
                if (this.timeCount == 1) {
                    this.timeCount++;
                    this.timeTemp = res.Value.Timestamp;
                }
                if (this.timeTemp != res.Value.Timestamp) {
                    this.alert.errorAlert('系统3秒后将刷新页面并读取最新彩种信息');
                    setTimeout(() => {
                        location.reload();
                    }, 3000);
                }
            }
        }).catch(err => { })
    }
    GetHangonToolSettings() {
        this.sysconfig.getHangonToolSettings().then((s) => {
            this.guaji = s.Data;
            if (s) {
                // 云挂机
                this.storage.write("CloudAfk", this.guaji.IsAllow);
                this.storage.writeString("CloudUrl", this.guaji.CloudUrl);
                // 计划软件
                this.storage.write("PlanAfk", this.guaji.IsAllowPlanSoft);
                this.storage.writeString("PlanSoftUrl", this.guaji.PlanSoftUrl);
                // 外接挂机
                this.storage.write("ExternalAfk", this.guaji.IsAllowExternal);
                this.storage.writeString("PcUrl", this.guaji.PcUrl);
            }
        });
    }

    /**
     * 打开云挂机
     */
    openAfkUrl() {
        if (this.storage.read("CloudAfk")) {
            //   if (this.storage.read("HasAfk")) {
            let encodePassord = this.storage.readString("AfkUrl");
            window.open(encodePassord, "_blank");
            //   }
        } else {
            this.alert.errorAlert("暂未开放敬请期待");
        }
    }

    /**
     * 打开外接挂机
     */
    openGuaji() {
        if (this.storage.read("ExternalAfk")) {
            this.router.navigateByUrl('/app/automatic-injection')
        } else {
            this.alert.errorAlert("暂未开放敬请期待");
        }
    }
    /**
     * 打开计划软件
     */
    opensoftwareplan() {
        if (this.storage.read("PlanAfk")) {
            let PlanSoftUrl = this.storage.readString("PlanSoftUrl");
            window.open(PlanSoftUrl, "_blank");
        } else {
            this.alert.errorAlert("暂未开放敬请期待");
        }
    }
    /**
     * 增加开元棋牌是否开启状态判断
     * evan 2018-12-28
     * @memberof PagesComponent
     */
    // getKaiYuanOpenStatus() {
    //     this.kaiyuanService.getKaiYuanIsOpen().then((res: ReturnResultModel) => {
    //         if (res && res.Result) {
    //             this.kaiyuanStatus = true;
    //         } else {
    //             this.kaiyuanStatus = false;
    //         }
    //     }).catch(err => {
    //         this.kaiyuanStatus = false;
    //     })
    // }

    lotteryInit() {
        for (let j = 0; j < this.lotterys.length; j++) {
            this.lotterys[j].openFlag = false;
        }
    }
    // opensoftwareplan() {
    //     this.sysconfig.getHangonToolSettings().then(s => {
    //         if (s.Value) {
    //             window.open(s.Data.PlanSoftUrl);
    //         }
    //     }).catch(c => {
    //         console.log(c)
    //     })
    // }
    change(i) {

        for (let j = 0; j < this.lotterys.length; j++) {
            if (j != i) {
                this.lotterys[j].openFlag = false;
            }
        }
        this.thirdGameList.forEach((element) => {
            element.isOpen = false;
        });
        this.openNavArr.forEach((element) => {
            if (element) {
                element = false;
            }
        });
    }

    /**
     *获取品牌logo
     *sing 2018 11 28
     * @returns
     * @memberof PagesComponent
     */
    // getLogoPic() {
    //     return this.sysconfig.getLogoPic().then(res => {
    //         if (res.length == 0) {
    //             this.logoSrc = '../../assets/imgs/common/logo.png';
    //             return;
    //         }
    //         this.logoSrc = res[0].ImgCode;
    //     }).catch(err => {
    //         this.logoSrc = '../../assets/imgs/common/logo.png';
    //     })
    // }

    /**
     * 获取APP的版本信息
     * Evan 2018-05-22
     *
     * @memberof PagesComponent
     */
    getAppQrcode() {
        this.indexService.getAppQrcode().then(s => {
            this.appInfo = s;
            s.AndroidDate = Moment(s.AndroidDate).format("YYYY-MM-DD");
            s.IosDate = Moment(s.IosDate).format("YYYY-MM-DD");
            $("#imgAndroid").qrcode({
                width: 90, //宽度
                height: 90, //高度
                text: s.AndroidUrl, //任意内容
                background: "#ffffff", //背景颜色
                foreground: "#f59932",//背景颜色

            });
            $("#imgIos").qrcode({
                width: 90, //宽度
                height: 90, //高度
                text: s.IosUrl, //任意内容
                background: "#ffffff", //背景颜色
                foreground: "#535353" //背景颜色
            });
        }, error => {
            this.alert.errorAlert('获取二维码异常，请尝试刷新页面');
        });
    }


    navToggle() {
        this.isUserNav = !this.isUserNav;
        this.isNavMenu = !this.isNavMenu;
    }
    // userNavBtn() {
    //     this.isUserNav = true;
    //     this.isNavMenu = false;
    // }

    /**
     * 点击更换下拉栏样式
     * sing：2018-05-26
     *
     * @memberof PagesComponent
     */
    toggleCollapsed() {
        this.isCollapsed = !this.isCollapsed;
        this.navShow = !this.navShow;
        let $content = $('.scroll-content');
        let $nav = $('.index-content')
        let setTime = 300;
        if (this.isCollapsed) {
            $nav.animate({ "width": "64px" }, setTime);
            $nav.removeClass("overflow-hidden");
            $content.animate({ "marginLeft": "64px" }, setTime);
        } else {
            $nav.animate({ "width": "255px" }, setTime);
            $nav.addClass("overflow-hidden");
            $content.animate({ "marginLeft": "255px" }, setTime);
        }
    }
    /**
     * 跳转到安全中心
     * sing： 2018-05-28
     * @memberof PagesComponent
     */
    goUserSafe(type) {
        if (type == 2) {
            this.router.navigate(['/app/manager/user-center'], { queryParams: { 'safeCenter': 'true' } });
        } else {
            this.router.navigate(['/app/manager/user-center'], { queryParams: { 'safeCenter': 'false' } });
        }
    }

    optionShow() {
        $(".operation-action").toggle();
    }

    public ngOnDestroy() {
        this.signalr.stop();
        clearInterval(this.guajiTimer);
    }

    logout() {
        AppConfig.connetionFlag = false;
        AppConfig.connection.stop(true, true);
        clearInterval(AppConfig.getCacheTimer);
        this.auth.logout();
    }

    // 记录当前彩种
    currLotterySet(code) {
        // 关闭其他侧拉栏
        for (let i = 0, len = this.openNavArr.length; i < len; i++) {
            this.openNavArr[i] = false;
        }
        this.currlotteryCode = code;
        this.activeLottery = parseInt(code);
        $(this).css('color', 'yellow').addClass("bg-yew").siblings().removeClass("bg-yew");
        if (this.currlotteryCode == code) {
            return;
        }
        this.alert.Loading();
        this.router.navigateByUrl('app/lottery/' + this.currlotteryCode);
        // let t = setInterval(function () {
        //     that.alert.CloseLoading();
        //     clearInterval(t);
        // }, 1000 * 3);
    }

    //获取客服二维码地址
    getkefuqecode() {
        this.sysconfig.getkefuqrcode().then(s => {
            if (!s[0].ImgCode) {
                return;
            }
            this.qrcode1 = s[0].ImgCode;
            this.qrcode2 = s[1].ImgCode;

        })
    }
    //声音开关初始化
    voiceSwitchInit() {
        this.switchValue = true ? this.soundState == true : this.soundState == false;
    }
    //彩种单击事件
    //TQQ 2017-04-25
    LotteryTypeClick(plays) {
        this.lotteryPlays = plays;
    }

    //彩票单击事件
    //TQQ 2017-04-25
    LotteryClick(lotterycode) {
        this.currlotteryCode = lotterycode;
        this.alert.Loading();
        this.router.navigateByUrl('app/lottery/' + lotterycode);
    }

    //彩票大厅的单击事件
    //TQQ 2017-06-02
    LotteryBig() {
        this.currlotteryCode = '10001';
        this.lotteryPlays = this.lotterys[1].plays;
    }

    /**
     * 获取所有第三方游戏是否开启开关
     *  rico - 2019-05-29
     * @memberof PagesComponent
     */
    getThirdIsOpen() {
        this.sysconfig.getThirdIsOpen().then(s => {
            if (s) {
                this.thirdGameList.forEach((thirdItem) => {
                    thirdItem.code;
                    if (s[thirdItem.code]) {
                        thirdItem.status = true;
                    }
                });
            }
        }).catch(err => {

        })
    }

    /**
     * 获取所有第三方游戏
     * @memberof PagesComponent
     */
    getOpenGames() {
        this.sysconfig.getOpenGames().then(s => {
            if (s.length) {
                this.thirdGameList = [];
                s[0].Games.forEach(el => {
                    let url = '';
                    url = this.AppConfig.OldThird.indexOf(',' + el.Code + ',') === -1 ? `/app/third/${el.Code}` : `/app/${el.Code}`;
                    let obj = {
                        code: el.Code,
                        // router: "/app/" + el.Code,
                        router: url,
                        name: el.Name,
                        status: true,
                        img: "https://upimg.haozigo.com/X03/images/pc-third/icon-" + el.Code + ".png",
                        isOpen: false,
                    }
                    this.thirdGameList.push(obj);
                });
                this.appconfig.thirdGameListSubject.next(this.thirdGameList);
                this.storage.write('THIRD_LIST',this.thirdGameList);
                // let obj = {
                //     code: 'sg',
                //     router: `/app/third/sg`,
                //     name: 'sg真人',
                //     status: true,
                //     img: "https://upimg.haozigo.com/X03/images/pc-third/icon-ag.png",
                //     isOpen: false,
                // }
                // this.thirdGameList.push(obj);
            }
        }).catch(c => {
            console.log(c)
        })
    }

    //侧边栏-TOP
    getTop() {
        $('body,html .layout').animate({ scrollTop: 0 }, 500);
        return false;
    }
    //侧边栏-微信
    weixin() {
        this.isWechat = !this.isWechat;
        this.isDownload = false;
    }

    //侧边栏-手机
    mobile() {
        this.isDownload = !this.isDownload;
        this.isWechat = false;
        this.getAppQrcode();
    }

    toggle() {
        $(".sidebar-toggle").toggleClass("toggle-open");
        this.isShow = !this.isShow;
    }

    //关闭侧边栏弹框
    close() {
        this.isWechat = false;
        this.isDownload = false;
    }

    openKefu() {
        let left = (window.outerWidth - 918) / 2;
        let top = (window.outerHeight - 700) / 2;
        let url = this.appconfig.getSysConfig().CustomerServiceUrl;
        let newWin = window.open("about:blank", '', 'left=' + left + ', top=' + top + ', toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=918, height=700');
        newWin.location.href = url;
    }

    getAllLottery() {
        var that = this;
        this.currUser = this.appconfig.getCurrentUser();
        this.lotterys = this.appconfig.getLotterys();
        //分出 急速彩
        let tmp = (new List(this.lotterys[0]['plays']).Where(s => {
            return s['LotteryName'].indexOf('时时彩') > -1 || s['LotteryName'] == '台湾5分彩'
        })).ToArray();
        // let tmptaiwan = (new List(this.lotterys).Where(s => s['name'] == '台湾五分彩')).ToArray();
        //急速彩
        let plays = (new List(this.lotterys[0]['plays']).Where(s => {
            return s['LotteryName'].indexOf('分') > -1 && s['LotteryName'] != '台湾5分彩'
        })).ToArray();
        // 时时彩去掉急速彩
        // let shishi = (new List(tmp[0]['plays']).Where(s => s['LotteryName'].indexOf('分') < 0)).ToArray();

        this.lotterys.forEach(s => {
            if (s['name'] == '时时彩') {
                s['plays'] = tmp;
            }
        });

        let tmplottery = { 'code': '10', 'name': '急速彩', 'plays': plays };
        this.lotterys.unshift(tmplottery);
    }
    //获取彩种信息
    getLottery() {
        this.lotterys = [];
        this.ttLottery = []; //时时彩数据
        let tabs = this.storage.read("lotterys");
        if (tabs == null) {
            this.router.navigateByUrl('/login');
            return;
        }
        let tt = this.groupBy.transform(tabs, "LotteryType");
        for (var i in tt) {
            let childData = [];
            let lotTempData = [];
            tt[i].forEach(s => {
                childData.push({ LotteryName: s.LotteryName, LotteryCode: s.LotteryCode });
                if (s.LotteryTypeName === "时时彩") {
                    lotTempData.push({ LotteryName: s.LotteryName, LotteryCode: s.LotteryCode });
                }
            });
            if (tt[i][0]["LotteryTypeName"] == "时时彩") {
                lotTempData = lotTempData.slice(0, 6);
                this.ttLottery.push({ id: i, typeName: tt[i][0]["LotteryTypeName"], data: lotTempData });
            }
        }
    }

    //刷新用户余额icon-refresh
    //TQQ 2017-05-17
    getUserMoney() {
        $('.icon-refresh').addClass('rot');
        this.isRefresh = true;
        this.userservice.getUserMoney().then(s => {
            let user = this.storage.read<UserModel>("User");
            $.extend(user, { 'UserMoney': s });
            this.storage.write("User", user);
            AppConfig.User = user;
            let t = setTimeout(() => {
                this.isRefresh = false;
                $('.icon-refresh').removeClass('rot');
                clearTimeout(t);
            }, 1000);
        }).catch(err => {
            this.isRefresh = true;
        })
    }

    //切换声音状态
    //TQQ 2017-05-18
    switchSound() {
        this.soundState = !this.soundState;
        this.cookie.remove('openSound');
        if (this.soundState) {
            this.cookie.put('openSound', 'on');
        } else {
            this.cookie.put('openSound', 'off');
        }
    }

    //头部点击事件
    //chen 2018-01-29
    recomd(obj) {
        if (obj.link) {
            // this.alert.Loading();
            this.router.navigateByUrl('/' + obj.link);
        } else {
            this.alert.errorAlert("敬请期待");
        }
    }


    goLottery(obj) {
        this.router.navigateByUrl('/app/lottery/' + obj.LotteryCode);
    }

    //点击头部图标隐藏显示侧拉栏 sing-2018-04-11
    changeStyle() {
        this.navShow = !this.navShow;
    }

    //公告跳转
    downLoadPage() {
        this.router.navigateByUrl('/app/download');
    }
    // domainname(){
    //     this.router.navigateByUrl('/app/download');
    // }
    //打印单
    //  printsheetPage() {
    //     this.router.navigateByUrl('/app/printsheetRecord');
    // }
    printsheetPage() {
        this.router.navigateByUrl('/app/manager/print-record/gameRecord');
    }
    //公告跳转
    noticePage() {
        this.router.navigateByUrl('/app/notice/0');
    }

    //获取网站公告
    //chen 2017-05-11
    getAnnouncements() {
        this.indexService.getAnnouncements().then(data => {
            if (data && data.length > 0) {
                this.isNotice = true;
            } else {
                this.isNotice = false;
            }
        })
    }

    // addHotIcon() {
    //     for (var i = 0; i < this.lotterys.length; i++) {
    //         for (var j = 0; j < this.lotterys[i].plays.length; j++) {
    //             var temp = this.lotterys[i].plays[j].LotteryName;
    //             if (temp == "重庆分分彩" || temp == "百度1.5分彩" || temp == "重庆时时彩" || temp == "客彩11选5" || temp == "芬兰1.5分彩" || temp == "吉隆坡1.5分彩" || temp == "广东11选5" || temp == "上海11选5" || temp == "客彩3D" || temp == "广西快3" || temp == "快乐飞艇" || temp == "PC蛋蛋") {
    //                 this.lotterys[i].plays[j].isHot = true;
    //             }
    //         }
    //     }
    // }

    //余额隐藏
    hidebalance() {
        this.isBalance = this.isBalance ? false : true;
    }

    /**
     * sing 2018-06-01
     * vr开启
     * @returns
     * @memberof PagesComponent
     */
    vrIsOpen() {
        const vrModelobj = {
            code: "vr",
            name: "VR真人彩票",
            img: "../../assets/imgs/pages/icon-VR.png",
            plays: [
                { LotteryName: 'VR金星1.5分彩', LotteryCode: "1", State: "01", isHot: false },
                { LotteryName: 'VR赛车', LotteryCode: "2", State: "01", isHot: false },
                { LotteryName: 'VR3分彩', LotteryCode: "11", State: "01", isHot: true },
                { LotteryName: 'VR快艇', LotteryCode: "13", State: "01", isHot: false },
                { LotteryName: 'VR彩票百家乐', LotteryCode: "15", State: "01", isHot: true },
                { LotteryName: 'VR六合彩', LotteryCode: "16", State: "01", isHot: false }
            ]
        };
        this.lotterys.unshift(vrModelobj);

    }



    taggles() {
        $(".drop-btn .drop-menu li").click(function () {
            $(this).addClass("active");
            $(this).siblings().removeClass("active");
        });
    }

    openLetteryTrend() {
        let url = 'lottery-trend/' + this.currlotteryCode;
        if (url == 'lottery-trend/95000') {
            this.alert.errorAlert('该彩种暂无走势图!')
            return;
        }
        let newWin = window.open("about:blank", '', 'left=200, top=100, toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=1260, height=800');
        newWin.location.href = url;
    }

    /**
     * david
     * 未开放内容弹窗
     * @memberof PagesComponent
     */
    noopen() {
        this.alert.errorAlert('暂未开放，敬请期待！');
    }

    /**
     * 非下拉彩種打開
     * @param {*} value
     * @memberof PagesComponent
     */
    openChange(value) {
        for (let i = 0, len = this.openNavArr.length; i < len; i++) {
            if (i == value) {
                continue;
            } else {
                this.openNavArr[i] = false;
            }
        }
        for (let j = 0; j < this.lotterys.length; j++) {
            this.lotterys[j].openFlag = false;
        }
        for (let k = 0; k < this.thirdGameList.length; k++) {
            this.thirdGameList[k].isOpen = false;
        }
    }
    thirdOpenChange(val) {
        this.thirdGameList.forEach((thirdGameItem) => {
            if (thirdGameItem.code == val.code) {
                thirdGameItem.isOpen = true;
            } else {
                thirdGameItem.isOpen = false;
            }
        });
        for (let j = 0; j < this.lotterys.length; j++) {
            this.lotterys[j].openFlag = false;
        }
        for (let k = 0; k < this.openNavArr.length; k++) {
            this.openNavArr[k] = false;
        }
    }
    /**
    *点击左侧栏不会改变其他开关
    *sing 20181025
    * @memberof PagesComponent
    */
    noOpenChange() {
        let timertwo = setTimeout(() => {
            this.openNavArr[4] = false;
            clearTimeout(timertwo);
        }, 1000);
    }

    openxinbao() {
        window.open("/app/xbbrand/about-us");
    }

    alershow() {
        if (this.currUser.UserType == '0') {
            this.alert.errorAlert("请联系上级升级为代理!");
        }

    }

    //  修改密码确定按钮
    handleOk() {
        const regex = /^[a-zA-z]\w{5,20}$/; //正则表达式验证用户名和密码
        if (this.pwdParams.oldpwd == '') {
            this.alert.errorAlert('请输入原密码');
        }
        else if (this.pwdParams.newpwd == '') {
            this.alert.errorAlert('请输入新密码');
            return;
        }
        else if (this.pwdParams.commpwd == '') {
            this.alert.errorAlert('请输入确认密码！');
            return;
        }
        else if (!regex.test(this.pwdParams.newpwd)) {
            this.alert.errorAlert('新密码格式不正确！');
            return;
        }
        else if (!regex.test(this.pwdParams.commpwd)) {
            this.alert.errorAlert('确认密码格式不正确！');
            return;
        }
        else if (this.pwdParams.newpwd != this.pwdParams.commpwd) {
            this.alert.errorAlert('新密码和确认密码不一致！');
            return;
        }
        else if (this.pwdParams.newpwd == this.currUser.UserName) {
            this.alert.errorAlert('为了保障账户安全，新密码不能和账户名一样');
            return;
        } else {
            this.signinService.IsCkSimplePwd({ userpwd: this.pwdParams.newpwd }).then(les => {
                this.isCkSimplePwd = les.Result;
                if (this.isCkSimplePwd) {
                    this.alert.errorAlert('您的密码过于简单，请重新设置（纯数字；单个字母加连贯数字；与账户相同的密码都为简单密码）！');
                    return;
                }
                this.userservice.updatePwd(this.pwdParams).then(res => {
                    if (res['Result']) {
                        this.alert.okAlert(res['Error']);
                        this.auth.logout();
                    } else {
                        this.alert.errorAlert(res['Error']);
                    }
                });
            });
        }
    }
    /**
     *
     * 获取未读消息总数
     */
    getChatNewMessage() {
        this.chatService.getChatNewMessage().then(res => {
            if (res) {
                this.badgenNum = res.Value;
            }
        }).catch(err => {

        })


    }

    /**
     *
     * 聊天黑名单
     */
    async getChatIsBanned() {
        return await this.chatService.getChatIsBanned().then(res => {
            if (res.Value) {
                this.isBanned = res.Value.IsBanned;
                this.isBlacklist = res.Value.IsBlacklist;
                if (!this.isBlacklist) {
                    this.getChatNewMessage();
                    this.poll = setInterval(() => {
                        this.getChatNewMessage();
                    }, 3000);
                }
            }
        }).catch(e => {
            console.log(e)
        });
    }
    /**
     * 上下级聊天窗口
     *
     */
    getCustomChatUrl() {
        if (this.isBlacklist) {
            this.alert.errorAlert('您已被列入黑名单，请联系客服！')
            return;
        }
        const left = (window.outerWidth - 918) / 2;
        const top = (window.outerHeight - 700) / 2;
        let winParams = ', toolbar=no, location=no, directories=no, status=no, menubar=no';
        winParams += ', scrollbars=no, resizable=no, copyhistory=no, width=918, height=700';
        const newWin = window.open('about:blank', 'chat', 'left=' + left + ', top=' + top + winParams);
        newWin.location.href = "chat/" + this.isBanned;
    }

    /**
     *
     * 是否开启上下级聊天
     */
    getChatSetting() {
        this.chatService.getChatSetting().then(res => {
            if (res.Value) {
                this.isOpenChat = res.Value.IsOpenChatMessage;
                if (this.isOpenChat) {
                    this.getChatIsBanned();
                }
            }
        }).catch(e => {
            console.log(e)
        })

    }
}

export class CacheModel {
    InnerMessage: string;
    Value: CacheTimer;
}
export class CacheTimer {
    Timestamp: number;
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/pages/pages.component.ts